"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M3.103 2h17.794C21.506 2 22 2.494 22 3.103v17.794c0 .609-.494 1.103-1.103 1.103h-5.104v-7.735h2.61l.001-.003h.017l.39-3.027h-3V9.306c0-.727.168-1.259.942-1.419a2.8 2.8 0 01.54-.047h1.604V5.138c-.773-.08-1.55-.12-2.328-.117-2.088 0-3.575 1.153-3.838 3.287a5.726 5.726 0 00-.041.702v2.228h-2.604v3.027h2.604V22H3.103A1.103 1.103 0 012 20.897V3.103C2 2.494 2.494 2 3.103 2z" }), "Facebook");
//# sourceMappingURL=Facebook.js.map